import React, { useState } from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/BaseElementsCSS/BaseElementsDesktop.css';

function Instructions({ hasAudio, instructionText, wordAudioUrl, instructionAudioUrl }) {
    const [audio, setAudio] = useState(null);
    
    const handleWordAudio = () => {
        if (audio) {
            audio.pause();
        }
        const newAudio = new Audio(wordAudioUrl);
        setAudio(newAudio);
        newAudio.play().then( () => {
        }).catch(e => {
            console.error('Error playing audio:', e);
        });
    };
    
    const handleInstructionAudio = () => {
        if (audio) {
            audio.pause();
        }
        const newAudio = new Audio(instructionAudioUrl);
        setAudio(newAudio);
        newAudio.play().then( () => {
        }).catch(e => {
            console.error('Error playing audio:', e);
        });
    };
    
    return (
        <div className="baseElementsInstructionRow">
            <div className="baseElementsInstructionsField">
                <p className="baseElementsInstructionsText">{instructionText}</p>
                <div className={"baseElementsInstructionButton row"}>
                    {hasAudio && (
                        <button
                            className="baseElementsAudioButton"
                            onClick={handleWordAudio}
                        >
                            <i className="bi bi-volume-up-fill"></i>Ascolta
                        </button>
                    )}
                    <div className='baseElementsHelpButton' onClick={handleInstructionAudio}></div>
                </div>
            </div>
        </div>
    );
}

export default Instructions;
